import React from "react";
import ReactDOM from "react-dom";
import ColorPickerComponent from "./ColorPickerComponent.js";

class ColorPickerUtil {
    static show = (positionX, positionY, radius, colorHex, Dyn, cb, colorsArray, theme) => {
        // To populate color picker
        let ele = document.getElementById("tde-color-picker-wrapper");
        if (!ele) {
            ele = document.createElement("div");
            ele.setAttribute("id", "tde-color-picker-wrapper");
            document.body.appendChild(ele);
        } else {
            ele.style.display = "block";
        }
        if (theme) {
            ele.setAttribute("class", "tde-theme-" + theme);
        }

        // Calculating the picker position based on the target element's position
        const pickerCss = {
            position: "fixed",
            zIndex: "1001", // Must be higher than context menu backdrop (1000) to receive clicks
        };
        const pickerWidth = 250;
        const pickerHeight = 250;
        const isYOverflowing = positionY + pickerHeight > window.innerHeight;
        if (isYOverflowing) {
            pickerCss.bottom = window.innerHeight - positionY + radius;
        } else {
            pickerCss.top = positionY + radius;
        }
        // To position the picker based on target element's position and available window width
        const isXOverflowing = positionX + pickerWidth > window.innerWidth;
        if (isXOverflowing) {
            pickerCss.right = window.innerWidth - positionX + radius;
        } else {
            pickerCss.left = positionX + radius;
        }

        // Close the picker on escape key press
        const closePicker = function () {
            ele.removeEventListener("click", handleClick);
            document.removeEventListener("keydown", handleKeyown);
            document.removeEventListener("focusin", focusTrap);
            eleRoot?.unmount();
            cb();
            ele.style.display = "none";
        };

        // Click handler for wrapper element
        const handleClick = function (event) {
            if (event.target.isSameNode(ele)) {
                closePicker();
            }
        };
        ele.addEventListener("click", handleClick);

        const handleKeyown = function (event) {
            // Close the picker on escape key press
            if (event.key === "Escape") {
                closePicker();
            }
            // Detect focus goes out of container while presseing tab
            if (event.key === "Tab") {
                if (event.shiftKey) {
                    if(document.activeElement.attributes?.["data-index"]?.value === "0") {
                        event.preventDefault();
                        closePicker();
                    }
                } else if(document.activeElement.tagName === "INPUT") {
                    event.preventDefault();
                    closePicker();
                }
            }
            // For Enter key press from input field only
            // Note: Enter on preset color buttons is handled by their onClick handlers
            if(event.key === "Enter" && document.activeElement.tagName === "INPUT") {
                setTimeout(() => {
                    closePicker();
                }, 100);
            }
        };
        document.addEventListener("keydown", handleKeyown);

        // Focus trap: prevent focus from leaving the color picker
        const focusTrap = function(event) {
            // If focus moves outside the color picker, bring it back
            if (!ele.contains(event.target)) {
                event.stopPropagation();
                event.preventDefault();
                // Return focus to the first focusable element in the picker
                const firstButton = ele.querySelector('.tde-picker-btn[data-index="0"]');
                if (firstButton) {
                    setTimeout(() => firstButton.focus(), 0);
                }
            }
        };
        document.addEventListener("focusin", focusTrap, true); // Use capture phase

        // Create react root and render the color picker component
        const eleRoot = ReactDOM.createRoot(ele);
        eleRoot.render(
            React.createElement(ColorPickerComponent, {
                handleChange: function (code) {
                    cb(code);
                },
                onClose: closePicker,
                style: pickerCss,
                color: colorHex,
                Dyn: Dyn,
                presetColors: colorsArray, // if defined, the array of colors to override the default colors
            })
        );
    };
}

export default ColorPickerUtil;
